import { timer as observableTimer, Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';
import { ChartService } from './services/chart.service';
import { ChartConfigurationWrapper, Size } from './models';
import { UserSettingsService } from '../user/services';
import { UserSetting } from '../user/models';
import { DateTimeService } from '../shared/datetime/datetime.service';

import { ChartPieComponent } from './chart-pie.component';
import { ChartCurveComponent } from './chart-curve.component';
import { ChartBarComponent } from './chart-bar.component';
import { ChartGridComponent } from './chart-grid.component';

@Component({
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.css'],
    selector: 'ep-chart-main-component',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ChartPieComponent, ChartCurveComponent, ChartBarComponent, ChartGridComponent]
})
export class ChartComponent implements OnInit,  OnDestroy  {

    constructor(private router: Router, private loadingPanelService: LoadingPanelService, private chartService: ChartService, private userSettingsService: UserSettingsService, public dateTimeService: DateTimeService) { }

    @Input() showHeadline = true;
    public timer: Observable<number>;
    public timerSub: Subscription;
    public timerInterval = 1000;
    public lastUpdate = new Date();
    public isUpdating = false;
    public showUpdatingTime = false;
    private SettingKey_Chart_Refreshtime = 'Setting_Chart_Refreshtime';
    chartRefreshtimeSetting: UserSetting = new UserSetting(this.SettingKey_Chart_Refreshtime, '', 'false', '5'); //disable the key by default with 5 seconds time to refresh;
    chartConfigurations: ChartConfigurationWrapper[] = [];

    ngOnInit() {
        this.loadData();
        this.userSettingsService.getSingleSetting(this.SettingKey_Chart_Refreshtime).then(setting => {
            this.chartRefreshtimeSetting = setting || this.chartRefreshtimeSetting;
            if (this.chartRefreshtimeSetting.Value1.toLowerCase() == 'true') {
                this.showUpdatingTime = true;
                this.timerInterval = parseInt(this.chartRefreshtimeSetting.Value2) * 1000; //converting it to milliseconds
                this.subscribe();
            }
        }
        ).catch(() => { });;
    }

    ngOnDestroy() {
        this.timerSub && this.timerSub.unsubscribe();
    }

    refreshData() {
        this.isUpdating = true;
        this.chartService.getConfigurations().then(result => { this.updateConfigurations(result); });
        this.lastUpdate = new Date();
        this.isUpdating = false;
    }

    private subscribe() {
        this.timer = observableTimer(this.timerInterval, this.timerInterval);
        this.timerSub = this.timer.subscribe(t => this.refreshData());
    }

    loadData() {
        this.loadingPanelService.showLoadingPanel(new LoadingPanelSettings('Initialize data...'));
        this.chartService.getConfigurations().then(result => {
            this.updateConfigurations(result);
            this.loadingPanelService.hideLoadingPanel();
        }).catch(() => this.loadingPanelService.hideLoadingPanel());
    }

    updateConfigurations(newConfigs: ChartConfigurationWrapper[]) {
        const mergedConfigs: ChartConfigurationWrapper[] = [];
        newConfigs.forEach(newConfig => {
            let currentConfig: ChartConfigurationWrapper = new ChartConfigurationWrapper(new Size(500, 500));

            const currentIndex = this.chartConfigurations.findIndex(currentConfig => currentConfig.Configuration.ChartConfigurationId === newConfig.Configuration.ChartConfigurationId);
            if (currentIndex >= 0) {currentConfig = this.chartConfigurations[currentIndex];}

            const mergedConfig: ChartConfigurationWrapper = { ...currentConfig, ...newConfig };
            mergedConfigs.push(mergedConfig);
        });
        this.chartConfigurations = mergedConfigs;
    }
}
